export default "__VITE_ASSET__fe8d77b4__"